import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {
  getFeatureIsLocked,
  getFeatureUnit,
  getPriceWithCurrency,
  toFixedFeatureCost,
  toFixedPrice
} from "../../../../../misc/helpers";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {getCurrentLayout} from "../../../../appLayout";
import {isVisibleForNavigation} from "../../../../../misc/displayLogic";
import LookFeaturePriceLocked from "./lookFeaturePriceLocked";
import {pricingIsLocked} from "../../lookNavigationFunctions";
import {getCartItemsCount} from "../../../grohe/groheNavigation/groheFunctions";
import MaterialSpinner from "../../../../ui/materialSpinner";
import FeaturePriceInput from "../../../../selectionWindow/selectionFeatureInfo/featurePriceInput";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {shouldSkipLock} from "../lookWizard/lookWizardFunctions3";

const LookFeaturePrice = (props) => {

  const {lookFeature, quantity, fabricatorData, intl, withUnit, isBundleChild, className, listPage, mainContentPrice,
    isPhoneNumberValidated, showPriceAlways, wizardGroup, shopPageOpened, shopPageLoaded} = props;
  const fabricatorSettings = fabricatorData.settings;

  if (!lookFeature) {
    return null;
  }

  const getQuote = fabricatorSettings.enableQuote && !isPhoneNumberValidated;

  let showPriceLocked = !showPriceAlways && getFeatureIsLocked(lookFeature);
  if (!showPriceLocked && listPage) {
    showPriceLocked = getQuote;
  }
  if (shouldSkipLock({wizardGroup})) {
    showPriceLocked = false;
  }
  const {showPrice} = pricingIsLocked();

  if (showPriceLocked) {
    if (!showPrice && listPage) {
      return null
    }
    let lockedText = <LookFeaturePriceLocked lookFeature={lookFeature} lockedText={getQuote ? "grohe.feature.locked" : null}/>;
    // if (getQuote) { // we already have icon and locked, we dont need $,icon,locked
      // lockedText = (
      //   <Fragment>
      //     <span className="ll-feature__price-sign">{fabricatorSettings.currencySign}</span>
      //     {lockedText}
      //   </Fragment>
      // )
    // }
    return className ? <div className={className}>{lockedText}</div> : lockedText
  }

  if (!showPrice || !isVisibleForNavigation(lookFeature, true)) {
    return null
  }

  const layout = getCurrentLayout();
  if (!layout.initialized && !(shopPageOpened && shopPageLoaded)) {
    return <MaterialSpinner size={14}/>
  }
  if (!listPage && !layout.partIdExistInQtCategory(lookFeature.partId, true) && !isBundleChild) {
    return null;
  }

  const featurePrice = +toFixedFeatureCost(lookFeature, Number.isInteger(quantity) ? quantity : 1);

  if (!featurePrice && !lookFeature.dbFeature.priceEditable) { // if it is zero - we are hiding the price, no need to show included
    return null
  }

  let unit = "";
  if (withUnit) {
    unit = getFeatureUnit(lookFeature, intl, fabricatorData);
  }

  if (mainContentPrice && document.kvConfig.isBackend && lookFeature.dbFeature.priceEditable) {
    const price = toFixedPrice(featurePrice);
    return <FeaturePriceInput unit={unit} feature={lookFeature} price={price} className={className}/>
  }

  const finalText = withUnit
    ? `${unit}: ${getPriceWithCurrency(fabricatorSettings, toFixedPrice(featurePrice), lookFeature)}`
    : getPriceWithCurrency(fabricatorSettings, toFixedPrice(featurePrice), lookFeature)

  return className ? <div className={className}>{finalText}</div> : finalText

};

LookFeaturePrice.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  withUnit: PropTypes.bool,
  quantity: PropTypes.number,
  className: PropTypes.string,
  listPage: PropTypes.bool,
  showPriceAlways: PropTypes.bool,
  mainContentPrice: PropTypes.bool,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {cartItems} = store.cartState; // to update component when user is logged in
  const cartItemsLength = getCartItemsCount(cartItems, ownProps.intl, true);
  const {qtCategoriesLoaded} = store.qtState; // to update price after categories are loaded

  // we need force here to check every time count is updated, it is just for update

  // const featureInfoCount = ownProps.lookFeature && ownProps.lookFeature.dbFeature
  // && ownProps.lookFeature.dbFeature.priceEditable && ownProps.mainContentPrice
  //   ? store.selectionState.featureInfoCount
  //   : null;

  const featureInfoCount = store.selectionState.featureInfoCount;
  const {shopPageOpened, shopPageLoaded} = store.shopState;

  return {
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated,
    cartItemsLength, // we need to reload item price if quantity is changed (complex logic dependency)
    qtCategoriesLoadedLength: qtCategoriesLoaded.length,
    featureInfoCount,
    shopPageOpened,
    shopPageLoaded,
  };
};

export default injectIntl(
  connect(mapStateToProps)(LookFeaturePrice)
)
